module.exports = __webpack_public_path__ + "static/media/identity-card.c2f1b5be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svg/identity-card.svg
// module id = 769
// module chunks = 0